<div class="nps-indicator">
  <img [src]="getNpsIndicator()" />
  <h5 class="text-center">{{ title }}</h5>
</div>
